import { styled, Typography } from '@mui/material';

const PepTitle = styled(Typography)({
  fontWeight: 'bold',
  fontSize: '13px',
});

export default PepTitle;
